import { Span } from "@tblabs/truffle";
import { Box } from "../../../../../Components/Utils/Box";
import { Router } from "../../../../../Services/Router";
import { StepEvent } from "../../../../../Steps/Step/StepEvent";


export class EventView extends Box
{
    constructor(private _router: Router, private event: StepEvent)
    {
        super(event.Icon);
        
        this.PositionRelative().Margin(4);

        this.OnClick(() => this._router.GoToOrderView(this.event.OrderId));

        this.Append(
            new Span(this.event.IsDone ? "✅" : "").FontSize(10).PositionAbsolute().Top(-4).Right(-4));
    }
}
